import { cn } from "./cn";

// Brand — v1's mark: a rounded gradient square with a punched-out dot, plus the wordmark with
// the second half in the accent. Small thing, big share of "this is a product not a demo".
export function Brand({ collapsed, className }: { collapsed?: boolean; className?: string }) {
  return (
    <div className={cn("flex items-center gap-[11px]", className)}>
      <div
        className="grid size-8 flex-none place-items-center rounded-[9px] bg-gradient-to-br from-accent to-[#5866DA] shadow-[0_8px_22px_-8px_var(--ozp-accent)]"
        aria-hidden
      >
        <span className="block size-[11px] rounded-full bg-bg" />
      </div>
      {!collapsed && (
        <span className="text-[18px] font-bold tracking-[-0.02em]">
          oz<span className="text-accent">panel</span>
        </span>
      )}
    </div>
  );
}
